import { MutationTree } from "vuex";
import { NationalIdState, NationalIdType } from "../types";

const mutations: MutationTree<NationalIdState> = {
  setNationalIdType(state, nationalIdType: NationalIdType) {
    state.nationalIdType = nationalIdType;
  },
  setNationalIdFrontBlob(state, nationalIdFrontBlob: Blob) {
    state.nationalIdFrontBlob = nationalIdFrontBlob;
  },
  setNationalIdBackBlob(state, nationalIdBackBlob: Blob) {
    state.nationalIdBackBlob = nationalIdBackBlob;
  },
};

export default mutations;
